import firebase from 'firebase';

export const getAccountabilityWeight = firebase.functions().httpsCallable('getAccountabilityWeight', {
  timeout: 600000,
});

export default 'accountabilityWeight.api.js';
